import script from "./CustomerSettingsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerSettingsTab.vue?vue&type=script&setup=true&lang=js"

import "./CustomerSettingsTab.vue?vue&type=style&index=0&id=53bafba6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53bafba6"]])

export default __exports__

/* vue-cli-plugin-import-components */

import ProfileArchive from "@/components/customers/profile/ProfileArchive.vue";
import ProfileBilling from "@/components/customers/profile/ProfileBilling.vue";
import ProfileCommunication from "@/components/customers/profile/ProfileCommunication.vue";
script.components = Object.assign({}, { ProfileArchive, ProfileBilling, ProfileCommunication }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { ProfileArchive, ProfileBilling, ProfileCommunication }, script.__o.components);}